import { Menu, MenuItem } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as DotsVerticalIcon } from "components/Icons/dots-vertical.svg";
import { OLTableActions } from "components/Table/OLTable";
import { useContextMenu } from "hooks/contextMenu";

const useStyles = makeStyles(() =>
  createStyles({
    MoreVertIcon: {
      cursor: "pointer",
      fontSize: 24,
    },
  }),
);

export function ReportContextMenu({
  actions,
}: {
  actions?: Array<OLTableActions>;
}) {
  const classes = useStyles();
  const contextMenu = useContextMenu();

  return (
    <>
      {actions && (
        <>
          <DotsVerticalIcon
            className={classes.MoreVertIcon}
            onClick={contextMenu.handleMenuOpen}
          />
          <Menu
            anchorEl={contextMenu.anchor}
            anchorOrigin={{
              horizontal: "center",
              vertical: "bottom",
            }}
            onClose={contextMenu.handleMenuClose}
            open={contextMenu.isMenuOpen}
            transformOrigin={{
              horizontal: "center",
              vertical: "top",
            }}
          >
            {actions.map((action: OLTableActions, index: number) => (
              <MenuItem
                key={index}
                onClick={() => {
                  action.action?.();
                  contextMenu.handleMenuClose();
                }}
              >
                {action.label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </>
  );
}
